import type { Validate } from 'react-hook-form';

export function combineValidators<T = string>(
  ...validators: Validate<T>[]
): Validate<T> {
  return function combinedValidator(value: T) {
    for (const validator of validators) {
      const result = validator(value);

      if (result === false || typeof result === 'string') {
        return result;
      }
    }

    return undefined;
  };
}
